import React, { useEffect, useState } from "react";

const PLACEHOLDER = "Enter AWB number (use commas for multiple)";
const PLACEHOLDER_SHORT = "Enter AWB numbers (use commas)"; // fits narrow phones
const NARROW = "(max-width: 600px)";

/** Full placeholder on wider screens, a shorter one where it would be cut off. */
const usePlaceholder = () => {
  const isNarrowNow = () => !!window.matchMedia && window.matchMedia(NARROW).matches;
  const [isNarrow, setIsNarrow] = useState(isNarrowNow);

  useEffect(() => {
    if (!window.matchMedia) return undefined;
    const mq = window.matchMedia(NARROW);
    const update = () => setIsNarrow(mq.matches);
    mq.addEventListener?.("change", update);
    return () => mq.removeEventListener?.("change", update);
  }, []);

  return isNarrow ? PLACEHOLDER_SHORT : PLACEHOLDER;
};

/** AWB input + Track button. Accepts several AWBs separated by commas/spaces. */
const SearchBar = ({ onTrack, loading = false }) => {
  const [value, setValue] = useState("");
  const placeholder = usePlaceholder();

  const submit = (e) => {
    e.preventDefault();
    const awbs = value.replace(/,/g, " ").replace(/\s+/g, " ").trim();
    if (!awbs) return;
    onTrack(awbs);
    setValue("");
  };

  return (
    <form className="search-bar" onSubmit={submit}>
      <input
        aria-label="AWB number"
        className="search-input"
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
      />
      <button type="submit" className="btn-primary" disabled={!value.trim() || loading}>
        {loading ? "Tracking…" : "Track"}
      </button>
    </form>
  );
};

export default SearchBar;
